import { render, staticRenderFns } from "./groupreademail.vue?vue&type=template&id=90c90dee&"
import script from "./groupreademail.vue?vue&type=script&lang=js&"
export * from "./groupreademail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports